export const aboutObj = {
  id: 'about',
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Title of the Company',
  headline: 'Sample headline goes here',
  description: 'Here we will place a detailed description of the service we are providing',
  buttonLabel: 'Get started',
  imgStart: false,
  img: require('../../images/svg-1.svg'),
  alt: 'Car',
  dark: true,
  primary: true,
  darkText: false
};

export const discoverObj = {
  id: 'discover',
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Discover a lot of things',
  headline: 'Sample headline about discover goes here',
  description: 'Here we will place a detailed description of the service we are providing that you can discover here',
  buttonLabel: 'Get started',
  imgStart: true,
  img: require('../../images/svg-2.svg'),
  alt: 'Car',
  dark: false,
  primary: false,
  darkText: true
};

export const signupObj = {
  id: 'signup',
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Create a new account',
  headline: 'Creating an account is extremely easy',
  description: 'Create a new account unless you already have one, and enjoy our offerings',
  buttonLabel: 'Get started',
  imgStart: false,
  img: require('../../images/svg-3.svg'),
  alt: 'svg3',
  dark: false,
  primary: false,
  darkText: true
};
